<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.ref"
            :error-messages="refErrors"
            :label="$t('contract.ref')"
            required
            @input="$v.item.ref.$touch()"
            @blur="$v.item.ref.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.start"
            :label="$t('contract.start')"
            :error-messages="startErrors"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.timeInit"
            :error-messages="timeInitErrors"
            :label="$t('contract.timeinit')"
            type="Number"
            @input="$v.item.timeInit.$touch()"
            @blur="$v.item.timeInit.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.timeUsed"
            :error-messages="timeUsedErrors"
            :label="$t('contract.timeused')"
            type="Number"
            @input="$v.item.timeUsed.$touch()"
            @blur="$v.item.timeUsed.$touch()"
          />
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="contracttypeSelectItems"
            v-model="item.type"
            :items="contracttypeSelectItems"
            :error-messages="typeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('contract.type')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customerSelectItems"
            v-model="item.customer"
            :items="customerSelectItems"
            :error-messages="customerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('contract.customer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="productSelectItems && item.customer"
            v-model="item.products"
            :items="productSelectItems"
            :error-messages="productsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('contract.products')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('contract.comment')"
            auto-grow
            rows="1"
            row-height="15"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';
import InputDate from '../InputDate';

export default {
  name: 'ContractForm',
  mixins: [validationMixin],
  components: {
    Loading,
    InputDate
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.customerGetSelectItems();
    this.contracttypeGetSelectItems();
    this.productGetSelectItems();

  },
  data() {
    return {
        ref: null,
        start: null,
        type: null,
        customer: null,
        products: null,
        comment: null,
        timeInit: 0,
        timeUsed: 0,
    };
  },
  computed: {
    isLoading() {
      return (
      this.isLoading_customer ||
      this.isLoading_contracttype ||
      this.isLoading_product
       );
    },
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    ...mapFields('contracttype', {
      contracttypeSelectItems: 'selectItems',
      isLoading_contracttype : 'isLoading'
    }),
    ...mapFields('product', {
      productSelectItems: 'selectItems',
      isLoading_product : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    refErrors() {
      const errors = [];

      if (!this.$v.item.ref.$dirty) return errors;

      has(this.violations, 'ref') && errors.push(this.violations.ref);

      !this.$v.item.ref.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    startErrors() {
      const errors = [];

      if (!this.$v.item.start.$dirty) return errors;

      has(this.violations, 'start') && errors.push(this.violations.start);


      return errors;
    },
    timeInitErrors() {
      const errors = [];
      if (!this.$v.item.timeInit.$dirty) return errors;
      has(this.violations, 'timeInit') && errors.push(this.violations.timeInit);
      return errors;
    },
    timeUsedErrors() {
      const errors = [];
      if (!this.$v.item.timeUsed.$dirty) return errors;
      has(this.violations, 'timeUsed') && errors.push(this.violations.timeUsed);
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.item.type.$dirty) return errors;
      has(this.violations, 'type') && errors.push(this.violations.type);
      return errors;
    },
    productsErrors() {
      const errors = [];
      if (!this.$v.item.products.$dirty) return errors;
      has(this.violations, 'products') && errors.push(this.violations.products);
      return errors;
    },
    customerErrors() {
      const errors = [];
      if (!this.$v.item.customer.$dirty) return errors;
      has(this.violations, 'customer') && errors.push(this.violations.customer);
      return errors;
    },
    commentErrors() {
      const errors = [];
      if (!this.$v.item.comment.$dirty) return errors;
      has(this.violations, 'comment') && errors.push(this.violations.comment);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {

    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems',
      productGetSelectItems: 'product/fetchSelectItems',
      contracttypeGetSelectItems: 'contracttype/fetchSelectItems',
    }),
    changeCustomer() {
      if (this.item.customer) {
        this.productGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] }]  });
      }
    },
  },
  validations: {
    item: {
      ref: {
        required,
      },
      start: {
      },
      customer: {
      },
      products: {
      },
      type: {
      },
      comment: {
      },
      timeInit: {
      },
      timeUsed: {
      },
    }
  },
  watch: {
    item() {
      if (this.item.customer) {
        this.productGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] }]  });
      } else {
        this.productGetSelectItems();
      }
    },
  }
};
</script>
